<template>
  <ComponentsLayoutWithNavbar id="item">
    <template #breadcrumbs>
      <Breadcrumbs
        class="pa-0"
        :items="breadcrumbs"/>
    </template>
    <template #main_content>
      <v-card
        class="width-100 content-card pa-0 main__green"
        elevation="0">
        <v-row>
          <v-skeleton-loader
            v-if="loading"
            :boilerplate="false"
            class="pt-4 pl-5"
            :tile="false"
            type="heading"
            width="300px"/>
          <v-card-title
            v-else
            class="flex flex-wrap flex-direction-column align-start pt-5">
            <span class="h1-headline">{{ '#' + application.number || '' }}</span>
            <v-subheader class="px-0 mt-2 h6-text">
              {{ application.title || $t('Catalog.NewPurchase') }}
            </v-subheader>
          </v-card-title>
          <PurchaseAgreBlock
            :can-agree.sync="canAgree"
            :elements="selected"
            :item="application"
            :loading="loading"
            @getAcceptors="getAcceptors"/>
        </v-row>

        <v-tabs
          ref="tabs"
          v-model="tab"
          background-color="var(--color-main-green)"
          class="tender-tabs tabs mb-5 "
          color="var(--black-color)"
          show-arrows>
          <v-tab
            v-for="(item, index) in tabs"
            :key="index"
            class="tab h7-text-medium px-3'"
            :data-qa="`tab-${item.value}`">
            {{ item.name }}
            <div
              v-if="item.count"
              class="tab__badge h9-text-bold black--text'"
              :data-qa="`tab-${item.value}-badge`">
              {{ item.count }}
            </div>
          </v-tab>
          <div class="spacer"/>

          <template v-if="tabs[tab] && tabs[tab].value == 'documents'">
            <ImportDialog
              :apply="addNewFiles"
              :create-file-handler="createFileHandler"
              :files.sync="new_fles"
              files-types
              subtitle=" "
              :title="$t('Tenders.AddNewDoc')">
              <template #activator="{ open }">
                <div>
                  <TooltipedBtn
                    data-qa="btn-add-new-file"
                    icon="add-file"
                    :text="$t('Tenders.AddNew')"
                    :texted="$vuetify.breakpoint.mdAndUp"
                    @click="open"/>
                </div>
              </template>
            </ImportDialog>
          </template>
        </v-tabs>
        <v-tabs-items
          id="content-container"
          v-model="tab"
          class="main__green">
          <v-tab-item data-qa="tab-rows">
            <PurchaseRows
              :application="application"
              :loading="loading"
              :selected.sync="selected"/>
          </v-tab-item>
          <v-tab-item>
            <PurchaseDocuments
              :attachments="attachments"/>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </template>
    <template #nav_bar="{ mini }">
      <v-container
        v-show="!mini"
        ref="info_container"
        class="purchase-info pa-0 main__light_green"
        :style="`height: calc(100% - ${selected.length > 1 ? '0' : '165'}px);`">
        <v-row
          class="pr-1 pt-6 pb-3"
          :class="{ ' secondary__green_chosen': allHistoryOpen }"
          justify="space-between"
          no-gutters>
          <v-col
            align-self="start"
            class="col-10"
            :class="(acceptors && acceptors.length) && !load_acceptors ? ' pl-4' : ' pl-7'">
            <v-row
              justify="start"
              no-gutters>
              <ListOfAcceptors
                :acceptors.sync="acceptors"
                :item.sync="application"
                :with_loading="load_acceptors"
                @updateAgreements="getAcceptors"/>
            </v-row>
          </v-col>
          <v-col class="col-2 pa-0 d-flex justify-end">
            <v-menu
              v-if="!loading"
              content-class="purch-card-options-menu menu"
              left
              offset-x
              offset-y>
              <template #activator="{ on }">
                <div v-on="on">
                  <sButton
                    small
                    type="text">
                    <sIcon
                      color="var(--black-color)"
                      type="menu"/>
                  </sButton>
                </div>
              </template>
              <div
                class="purch-card-menu menu"
                dense>
                <CopyItem
                  :copy-item="$_copyApp"
                  list/>
                <ToggleTemplates
                  :add="!application.inTemplates"
                  list
                  @click="toggleTemplate"/>
                <InDevelopmentInfo condition>
                  <template #activator>
                    <MenuItem
                      data-qa="publish-current-release"
                      icon="share"
                      :label="$t('Purchasing.Share')"/>
                  </template>
                </InDevelopmentInfo>
                <MenuItem
                  :data-qa="details ? 'hide-details' : 'see-details'"
                  icon="table"
                  :label="details ? $t('Application.HideDetails') : $t('Application.SeeDetails')"
                  @click="details = !details"/>
                <InDevelopmentInfo
                  :condition="CHAT_IN_DEVELOPMENT"
                  prevent>
                  <template #activator>
                    <MenuItem
                      data-qa="check-chat"
                      :disabled="selected.length > 1 || load_join_chat || CHAT_IN_DEVELOPMENT"
                      icon="comment"
                      :label="!in_chat ? $t('Common.JoinChat') : $t('Common.ExitChat')"
                      @click="checkChat"/>
                  </template>
                </InDevelopmentInfo>
              </div>
            </v-menu>
          </v-col>
        </v-row>

        <v-row
          v-if="details"
          align="center"
          class="pl-12"
          no-gutters>
          <v-col>
            <v-list>
              <v-subheader class="px-0 ">
                {{ $t('Application.WhoCreated') }}
              </v-subheader>
              <v-list-item class="px-0 pb-3">
                <v-list-item-avatar>
                  <UserIcon
                    class="avatar"
                    :name="application.creator ? application.creator.fullName : ''"
                    size="28"
                    :src="application.creator ? application.creator.avatar : ''"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="names">
                    {{ noData(application.creator ? application.creator.fullName : '') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="px-0 subheader">
                    {{ noData(application.creator && application.creator.department
                      ? application.creator.department.name : '') }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-subheader class="px-0 subheader">
                {{ $t('Application.WhereToSend') }}
              </v-subheader>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title
                    v-if="application.receiver"
                    class="names">
                    <div>{{ application.receiver.name }}</div>
                    <div>{{ application.receiver.address }}</div>
                  </v-list-item-title>
                  <v-list-item-title
                    v-else
                    class="names">
                    {{ $t('Common.NoData') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <sDivider v-if="details"/>
        <History
          v-if="!history_loading"
          :application="application"
          :comments="chats"
          :custom_class="(details ? 'details' : 'nodetails') + ' pl-4'"
          :history="history"
          :in_chat="in_chat"
          :selected="selected"
          :user="my_user_info"/>
        <template v-else>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            :boilerplate="false"
            class="history-loader d-flex mr-4 ml-7 mb-4"
            :tile="false"
            type="avatar, sentences"
            width="200px"/>
        </template>
      </v-container>
      <InDevelopmentInfo
        v-show="!mini"
        :condition="CHAT_IN_DEVELOPMENT"
        prevent>
        <template #activator>
          <SendMessageBlock
            v-if="(selected.length < 2) && !loading"
            :chat="selected.length ? selected[0].chat : application.chat"
            :in_chat="in_chat"
            :join-chat="joinChat"
            :row="selected.length ? selected[0] : null"
            :send-comment="send"
            type="APP"
            :user="my_user_info"/>
        </template>
      </InDevelopmentInfo>
    </template>
  </ComponentsLayoutWithNavbar>
</template>

<script>
import PurchaseRows from 'components/purchasing/purch item/block/PurchaseRows.vue'
import PurchaseDocuments from 'components/purchasing/purch item/block/PurchaseDocuments.vue'
import ImportDialog from 'components/common/dialogs/ImportDialog.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

import MenuItem from 'components/common/MenuItem.vue'
import UserIcon from 'components/header/UserIcon.vue'
import CopyItem from 'components/common/elements/CopyItem.vue'
import History from 'components/common/blocks/history/History.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import ListOfAcceptors from 'components/agreement/ListOfAcceptors.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'
import SendMessageBlock from 'components/common/blocks/SendMessageBlock.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import PurchaseAgreBlock from 'components/purchasing/purch item/block/PurchaseAgreBlock.vue'

import { snackbarMixin, filterSortMixin, applicationMixin, fetchQuerys, modalMixin } from 'mixins'

import { StorageFile } from '@/types/commonFile.js'

import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

import ApplicationsApi from '@/api/applicationApi'
import CatalogueApi from '@/api/catalogueApi'

import NotificationApi from '@/api/notificationApi'
import SmarttenderApi from '@/api/smarttenderApi'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { eventBus } from '@/main'

const notif_api = new NotificationApi()

const api = new ApplicationsApi()
const catalog_api = new CatalogueApi()
const tender_api = new SmarttenderApi()

/**
Страница планов закупок
':locale?/:org(\\d+)/planning/:id'
*/

export default {
  name: 'itemComponent',
  mixins: [snackbarMixin, filterSortMixin, applicationMixin, fetchQuerys, modalMixin],
  data() {
    return {
      tab: 0,

      CHAT_IN_DEVELOPMENT: true,

      selected: [],
      details: false,
      allHistoryOpen: false,
      application: {},
      itemId: '',
      comments: [],
      loading: true,
      load_acceptors: true,
      history_loading: true,
      in_chat: false,
      load_join_chat: false,
      agree_loading: null,
      tenderStatuses: {
        '0': {}
      },
      members: [],
      canAgree: false,
      acceptors: [],
      chats: [],
      history: [],

      attachments: [],
      new_fles: [],
    }
  },
  props: {
    mode: String,
  },
  async created() {
    this.itemId = this.$route.params?.id
    this.$root.$on('updateEvents', this.updateEvents)
    this.getApps()
    this.fetchAttachments()

    if (!this.isActiveSignalR) {
      eventBus.$emit('ShowSignalAlert', 'Отримання закупки')
      return
    } else {
      await this.$notifier.onPage(this.itemId?.toString(), 1)
    }
  },
  computed: {
    ...mapGetters({
      my_user_info: 'GET_USER'
    }),
    ...mapGetters('notification', ['isActiveSignalR']),
    tabs() {
      return [
        {
          name: this.$t('Application.Rows'),
          value: 'rows',
          count: this.application?.rows?.length
        },
        {
          name: this.$t('Tenders.Documents'),
          value: 'documents',
          count: this.attachments?.length
        },
      ]
    },
    user_id() {
      return this.my_user_info?.purchasingSettings?.userId?.trim()
    },
    breadcrumbs() {
      return [
        {
          text: this.$t(`Menu.${this.mode[0].toUpperCase() + this.mode.slice(1)}`),
          action: () => this.$router.push({ name: this.mode, params: { org: this.$route.params.org } })
        },
        {
          text: '#' + this.application.number,
          loading: this.loading
        },
      ]
    },
    applicationId() {
      return this.$route.params.id
    },
    /*onlyChecked() {
      //TODO: сейчас с бека статус строки не приходит нигде. Соответсвенно, логика не рабочая
      return !!this.groups?.every(el => el.code == '+' || el.code == '–')
    },*/
  },
  methods: {
    async addNewFiles() {
      this.new_fles.forEach((file) => {
        file.uploadFile()
          .then(res => {
            if (res) {
              file.key = res
              file.fileId = res
              file.uri = `${window.config.GrapgQlUrl}/document/${res}`
              this.attachments.unshift(file)
            } else {
              file.error = true
            }
          })
      })
      this.new_fles = []
    },
    createFileHandler(file) {
      file.title = file.name
      file.dateModified = new Date()
      return new StorageFile(this.itemId, file, 'Purchasing')
    },
    async fetchAttachments() {
      files_api.getFileList(this.itemId, 'Purchasing')
        .then((res) => {
          const files = res.map((file) => {
            const fileConvert = {
              title: file.fileName,
              size: file.size,
              key: file.id,
              created: file.modifier.userName,
              ...file
            }
            return new StorageFile(this.itemId, fileConvert, 'Purchasing')
          })
          this.attachments = files.sort((a, b) => new Date(b.dateModified) - new Date(a.dateModified))
        })
    },
    getTenderStatuses() {
      let rows = this.application.rows.filter(r => r.bindedTenders?.length > 0),
        bindedTenders = rows.map(r => r.bindedTenders.find(el => !el.cancelled && el?.tenderId) || r.bindedTenders[0]),
        tenderIds = bindedTenders.map(r => r?.tenderId)
      tenderIds = [...new Set(tenderIds)]
      if (!tenderIds.length || tenderIds.some(el => !el)) {
        return ''
      }
      let promices = tenderIds.map(id => tender_api.getTenderNameStatus(id)
        .then(resp => {
          rows.find(row => row.bindedTenders.find(el => !el.cancelled && el?.tenderId == resp.tenderId)
            || row.bindedTenders.find(el => el?.tenderId == resp.tenderId)).tender = resp
          // t.$set(t.tenderStatuses, id, {tenderStatusTitle: resp?.title, tenderStatusId: resp?.statusCode})
        }))

      return Promise.all(promices)
    },
    noData(val) {
      if (!val || val.trim() == '') {
        return this.$t('Common.NoData')
      } else {
        return val
      }
    },
    agreeApplicationForeach(el, decision) {
      let row = this.$_.find(this.application.rows, ['id', el.id])
      let status = this.$_.find(row.applicationRowStatuses, ['userId', this.my_user_info.id])
      if (status) {
        if (decision) {
          status.statusRowId = '+'
          status.statusRow ? status.statusRow.name = this.$t('Application.Success') : ''
        } else {
          status.statusRowId = '–'
          status.statusRow ? status.statusRow.name = this.$t('Application.Decline') : ''
        }
      }
    },
    async getResource(id) {
      await catalog_api.getResourceById(id)
    },
    async getApps() {
      return await api.getApplicationById(this.applicationId)
        .then(this.getApplicationCallback)
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading = false
          this.history_loading = false
        })
    },
    async getApplicationCallback(responce) {
      this.application = responce.data?.applications[0]
      if (this.application?.state == 'П') {
        return this.$router.push({ name: 'editing', query: { id: this.application?.id }, params: { org: this.$route.params.org } })
      }
      if (!this.application) {
        this.$router.push({ name: 'page-error', params: { status_code: 404, descript: 'ItemComponent' } })
      }
      this.loading = false

      this.getTenderStatuses()

      this.getAcceptors()
      await api.getApplicationEvents(+this.itemId)
        .then(res => {
          this.history = res.data.changeHistory
        })
      if (!this.CHAT_IN_DEVELOPMENT) {
        await api.getApplicationChats(+this.itemId)
          .then(res => {
            this.chats = res.data.chats
            this.application.chat = this.getChat()
            this.application.rows.forEach(row => row.chat = this.getChat(row.id))
            this.inChat()
          })
      }
      this.history_loading = false
    },
    async getAcceptors() {
      await api.getApplicationAcceptors(+this.itemId)
        .then(res => {
          this.application.acceptors = res
          this.acceptors = res
          this.canAgree = res?.some(el => el.status == 'Waiting' && el.user?.id?.trim() == this.user_id)
        })
        .catch(this.$log_error)
        .finally(() => this.load_acceptors = false)
    },
    async joinChat() {
      this.load_join_chat = true
      let pushToChat = (elem, item) => elem?.chat?.chatUsers.push(item)
      await notif_api.joinToChat(this.selected.length == 1 ? this.selected[0].chat?.id : this.application.chat?.id)
        .then(res => {
          res = res?.data?.joinToChat
          if (this.selected.length == 1) {
            pushToChat(this.selected[0], res)
          } else {
            pushToChat(this.application, res)
          }
          this.inChat()
          this.load_join_chat = false
        })
    },
    async exitChat() {
      this.load_join_chat = true
      let filterChat = (elem, item) => elem?.chat?.chatUsers.filter(el => el.user?.id != item)
      await notif_api.exitChat(this.selected.length == 1 ? this.selected[0].chat?.id : this.application?.chat?.id)
        .then(res => {
          res = res?.data?.exitChat?.user?.id
          if (this.selected.length == 1 && this.selected[0].chat) {
            this.selected[0].chat.chatUsers = filterChat(this.selected[0], res)
          } else if (this.application?.chat) {
            this.application.chat.chatUsers = filterChat(this.application, res)
          }
          this.inChat()
          this.load_join_chat = false
        })
    },
    checkChat() {
      !this.in_chat ? this.joinChat() : this.exitChat()
    },
    getChat(id) {
      return this.chats?.find(chat => chat?.chatType?.trim() == (id ? 'ROW' : 'APP')
        && (!id || chat?.chatKey?.trim()?.split('/')[1] == id))
    },
    inChat(app) {
      let user = this.user_id || {},
        check_in_chat = (chat) => chat?.chatUsers?.find(el => el.user.id == user),
        app_chat = this.application.chat,
        in_app_chat = check_in_chat(app_chat),
        hasnt_selected = !this.selected.length || this.selected.length > 1

      if (app || hasnt_selected) {
        return this.in_chat = !!in_app_chat
      } else {
        let selected_chat = this.selected[0].chat,
          in_selected_chat = check_in_chat(selected_chat)
        return this.in_chat = !!in_selected_chat
      }
    },
    async send(type, message) {
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Відправка закупки')
        return
      }
      if (!this.CHAT_IN_DEVELOPMENT) {
        this.$notifier.notify(+this.itemId, this.selected[0]?.id, type, message)
      }
    },
    updateEvents(optins) {
      let event
      if (optins.headerId == this.itemId) {
        event = { ...optins.events[0], __typename: 'ApplicationEventGraph' }
        this.application.events.push(event)
        if (event.rowId) {
          this.application.rows.some(el => {
            if (el.id == event.rowId) {
              el.events.push(event)
              return true
            }
          })
        }
        this.$root.$emit('updateHisory', event, true)
      }
    },
    updateAllHisory() {
      api.getApplicationEvents(this.itemId)
        .then(res => {
          res = res.data.applications[0]
          this.application.events = res?.events
          this.application.rows?.forEach(row => {
            row.events = res?.rows?.find(el => el.id == row.id)?.events
          })
          this.$root.$emit('updateAllHisory')
        })
    }
  },
  watch: {
    selected(val) {
      if (val.length > 0) {
        if (val.length == 1) {
          this.inChat()
        }
        this.$_openSnackbar({
          name: 'item',
          elements: val,
          item: this.application,
          user: this.my_user_info,
          canAgree: this.canAgree,
          yourTurn: this.canAgree,
          joinChat: this.joinChat,
          rejectChoosed: () => { this.selected = [] },
          callback: (quantity, comment, date_type, date) => {
            let item = this.selected[0],
              row = {
                'id': item.id,
                'headerId': +this.itemId,
                'priorityId': date_type || (date ? '' : item.approvedPriority.id) || '',
                'quantity': quantity || item.approvedQuantity,
                'supplyDate': date ? moment(date).format('YYYY-MM-DD') : (date_type || item.approvedPriority.id ? null : moment(item.approvedSupplyDate).format('YYYY-MM-DD')),
                'urgentReason': (date_type == 'U' ? comment : item.approvedPriority.id == 'U' ? item.urgentReason : '') || ''
              }
            api.editApplicationRow(row, comment || '')
              .then(() => {
                this.application.rows[this.application.rows.findIndex(el => el.id == item.id)].urgentReason = row.urgentReason
              })
            this.selected = []
          }
        })
      } else if (val.length == 0) {
        this.$_closeSnackbar()
        this.inChat()
      }
    },
  },
  async beforeDestroy() {
    this.$root.$off('updateEvents', this.updateEvents)

    if (!this.CHAT_IN_DEVELOPMENT) {
      if (this.application.chat && this.inChat(true)) {
        notif_api.signLastVisit(this.application.chat?.id)
          .catch(res => this.$log_error(res))
      }
    }

    if (!this.isActiveSignalR) {
      eventBus.$emit('ShowSignalAlert', 'Вихід з закупки')
      return
    }
    await this.$notifier.outPage(this.itemId.toString(), 1)
  },
  components: {
    History,
    MenuItem,
    UserIcon,
    CopyItem,
    Breadcrumbs,
    PurchaseRows,
    ImportDialog,
    TooltipedBtn,
    ToggleTemplates,
    ListOfAcceptors,
    SendMessageBlock,
    PurchaseAgreBlock,
    PurchaseDocuments,
    InDevelopmentInfo,
    ComponentsLayoutWithNavbar,
  }
}
</script>
<style lang="scss" scoped>
.content-card {
  .children-count {
    height: 15px;
    background: var(--black-color);
    color: var(--white-color);
    border-radius: 6px;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    vertical-align: middle;
  }
  .v-card__title {
    span {
      font-weight: 500;
      font-size: 32px;
    }
    .v-subheader:first-child {
      color: #A0A4A8;
    }
  }
  .card-title-text {
    line-height: 20px;
    letter-spacing: -0.02em !important;
  }
  .v-card__actions .btn {
    font-weight: 600;
    font-size: 11px;
  }
  .changed-item-text {
    font-size: 11px;
    line-height: 12px;
  }
  .comments {
    span {
      height: 16px;
      color: var(--black-color);
    }

    &.v-btn--disabled {
      opacity: 0.5;
    }
  }
}
.v-subheader {
  height: unset !important;
}
.purchase-info {
  overflow: hidden;
  .v-subheader {
    font-size: 12px;
  }
  .btn {
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 0.03em;
  }
  .secondary__green_chosen {
    position: sticky;
    top: 0;
    z-index: 6;
  }
}
.names {
  font-size: 13px;
  text-align: start;
  color: var(--black-color);
  white-space: normal;
}
.name {
  font-weight: 500;
}
.avatars {
  position: absolute;
  top: 0px
}
.avatars.block {
  position: relative;
  min-width: 50px;
  height: 50px;
}
.v-list-item__avatar {
  margin-right: 4px !important;
}
.divider {
  border: 1px solid black !important;
  margin: 2px 0;
}
.ready-text {
  text-align: start;
  color: var(--black-color);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.avatars.block {
  position: relative;
  height: 30px;
  max-height: 30px;
  display: inline-block;
  .avatars {
    position: relative;
    top: 0px;
    border-radius: 15px;
  }
}
.status-chip {
  cursor: pointer;
}
</style>
<style lang="scss">
#components-layout-item {
  .history-container {
    &.details {
      height: calc(100% - 260px);
    }
    &.nodetails {
      height: calc(100% - 90px);
    }
  }
  .v-skeleton-loader .v-skeleton-loader__table-thead,
  .v-skeleton-loader .v-skeleton-loader__table-tbody {
    background-color: var(--v-main__green-base);
  }

  .v-expansion-panel-header {
    border-bottom: 1px solid var(--v-secondary__green_chosen-base);
    min-height: 60px;
    height: 60px;

    &.v-expansion-panel-header--active {
      min-height: 60px;
      height: 60px;
      margin-bottom: 24px;
    }
  }

  .v-expansion-panel:not(:first-child)::after {
    border-top: none;
  }

  .v-expansion-panel::before {
    box-shadow: none
  }
  .v-data-table__wrapper {
    max-height: calc(100vh - 185px);

    table tbody tr {
      cursor: pointer;
      td.text-start:not(:first-child) {
        padding: 10px !important;
      }
    }
  }
}
.tab__badge {
  position: relative;
  bottom: 5px;
  left: 4px;
}
</style>
